import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { NAMESPACES } from "@/constants/i18next.constants";
import { QUERY_KEYS } from "@/constants/queryKeys";

import { getInstallationList } from "./InstallationSelect.services";

export const useGetInstallationList = () => useQuery({
  queryKey: [QUERY_KEYS.DASHBOARD_INSTALLATION_LIST],
  queryFn: getInstallationList,
});

export const useGetInstallationSelectOptions = ({ showAll }: { showAll: boolean }) => {
  const { t } = useTranslation([NAMESPACES.LAYOUT]);
  const { data, isPending } = useGetInstallationList();

  const options = useMemo(() => {
    if (!data) {
      return [];
    }
    const options = data.results.map(result => ({
      value: result.ref,
      label: result.label,
    }));

    if (showAll) {
      options.unshift({
        value: "",
        label: t("installationSelect.showAll"),
      });
    }

    return options;
  }, [
    data,
    t,
    showAll,
  ]);

  return {
    options,
    isPending,
  };
};
